var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{staticClass:"new"},[_c('PanelWithSessionEditor',{attrs:{"edit":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }